module.exports = __webpack_public_path__ + "img/f2.1807f0ef.png";